var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 50.024,
    viewBox: "0 0 48 50.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(11,183,167,0.4);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.359 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.359 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M56.045,25.658a1.466,1.466,0,0,1,0-1.3l1.866-3.817a4.343,4.343,0,0,0-1.874-5.767l-3.753-1.991a1.466,1.466,0,0,1-.762-1.048l-.734-4.185a4.343,4.343,0,0,0-4.905-3.564l-4.206.6a1.466,1.466,0,0,1-1.232-.4L37.391,1.232a4.342,4.342,0,0,0-6.064,0L28.274,4.186a1.466,1.466,0,0,1-1.232.4l-4.206-.6A4.342,4.342,0,0,0,17.93,7.555L17.2,11.74a1.466,1.466,0,0,1-.762,1.048l-3.753,1.991a4.343,4.343,0,0,0-1.874,5.767l1.866,3.817a1.466,1.466,0,0,1,0,1.3l-1.866,3.817a4.343,4.343,0,0,0,1.874,5.767l3.753,1.991a1.466,1.466,0,0,1,.762,1.048l.734,4.185a4.34,4.34,0,0,0,4.281,3.608,4.462,4.462,0,0,0,.625-.044l4.206-.6a1.466,1.466,0,0,1,1.232.4l3.053,2.954a4.342,4.342,0,0,0,6.063,0l3.053-2.954a1.467,1.467,0,0,1,1.232-.4l4.206.6a4.342,4.342,0,0,0,4.905-3.564l.734-4.184a1.466,1.466,0,0,1,.762-1.048l3.753-1.991a4.343,4.343,0,0,0,1.874-5.767Zm-1.36,7.035-3.753,1.991a4.333,4.333,0,0,0-2.251,3.1l-.734,4.184a1.469,1.469,0,0,1-1.66,1.206l-4.206-.6a4.332,4.332,0,0,0-3.642,1.183l-3.053,2.954a1.469,1.469,0,0,1-2.051,0L30.28,43.761a4.328,4.328,0,0,0-3.022-1.227,4.428,4.428,0,0,0-.621.044l-4.206.6a1.47,1.47,0,0,1-1.66-1.206l-.734-4.185a4.332,4.332,0,0,0-2.251-3.1l-3.753-1.991a1.469,1.469,0,0,1-.634-1.951l1.866-3.817a4.333,4.333,0,0,0,0-3.83L13.4,19.279a1.469,1.469,0,0,1,.634-1.951l3.753-1.991a4.333,4.333,0,0,0,2.251-3.1l.734-4.184a1.469,1.469,0,0,1,1.66-1.206l4.206.6A4.333,4.333,0,0,0,30.28,6.259l3.053-2.954a1.469,1.469,0,0,1,2.051,0l3.053,2.954A4.332,4.332,0,0,0,42.08,7.443l4.206-.6a1.469,1.469,0,0,1,1.66,1.206l.734,4.185a4.332,4.332,0,0,0,2.251,3.1l3.753,1.991a1.469,1.469,0,0,1,.634,1.951L53.453,23.1a4.333,4.333,0,0,0,0,3.83l1.866,3.817A1.469,1.469,0,0,1,54.684,32.693Z",
    transform: "translate(-10.359 0.002)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.396 14.047)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M165.3,144.214a1.443,1.443,0,0,0-2.04,0l-19.041,19.041a1.443,1.443,0,1,0,2.04,2.04L165.3,146.254A1.442,1.442,0,0,0,165.3,144.214Z",
    transform: "translate(-143.791 -143.791)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.299 12.027)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M148.092,123.116a5.29,5.29,0,1,0,5.29,5.29A5.3,5.3,0,0,0,148.092,123.116Zm0,7.694a2.4,2.4,0,1,1,2.4-2.4A2.407,2.407,0,0,1,148.092,130.81Z",
    transform: "translate(-142.802 -123.116)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.84 27.415)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M266.212,280.61a5.29,5.29,0,1,0,5.29,5.29A5.3,5.3,0,0,0,266.212,280.61Zm0,7.694a2.4,2.4,0,1,1,2.4-2.4A2.407,2.407,0,0,1,266.212,288.3Z",
    transform: "translate(-260.922 -280.61)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.0709411cf7ce3353dd755780f38e68ab.svg";
export { ForwardRef as ReactComponent };